import completeInfo from './completeInfo';
import completeRegistration from './completeRegistration';
import changePassword from './changePassword';
import changeEmail from './changeEmail';
import changeAvatar from './changeAvatar';
import uploadFile from './uploadFile';
import updateUser from './updateUser';
import upgradeUser from './upgradeUser';
import updateWelcomeSettings from './updateWelcomeSettings';
import disableAudioConnectionPrompt from './disableAudioConnectionPrompt';
import validateSchoolMembership from './validateSchoolMembership';
import updateUserEmail from './updateUserEmail';

export default {
  completeInfo,
  completeRegistration,
  changePassword,
  changeEmail,
  changeAvatar,
  uploadFile,
  updateUser,
  upgradeUser,
  updateWelcomeSettings,
  disableAudioConnectionPrompt,
  validateSchoolMembership,
  updateUserEmail,
};



// WEBPACK FOOTER //
// ./src/app/services/account/index.js